import { compose } from 'recompose';
import SubDReplenishment from './SubDReplenishment';
import { query, mutation } from './API';
import withRequestTracker from '../../../../utils/composition/withRequestTracker';

const composedSubDReplenishment = compose(withRequestTracker({ query, mutation }))(SubDReplenishment);

export default composedSubDReplenishment;
